//import { Row, Col, Image, ListGroup, Form, Button } from "react-bootstrap";
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';

import RemoveFromCartComponent from "./RemoveFromCartComponent";

const { strCurrency, strEuroCurrency } = require('../utils/currencyUtils.js')

const CartItemComponent = ({ item, removeFromCartHandler = false, orderCreated = false, changeCount = false }) => {
  return (
    <>
        <Grid container spacing={2}
          sx={{
            paddingTop: 0, paddingBottom: 0, paddingLeft: 2, paddingRight: 2,

          }}
        >
          <Grid size={{ xs: 3, md: 4 }}>
            <Box
              component="img"
              src={item.image ? item.image.path ?? null : null}
              sx={{ display: { xs: 'flex', md: 'flex' }, 
                    border: 1, 
                    height:75,
                      '@media (min-width: 600px)': { height: '150px' },
                  }}
            />
          </Grid>

          <Grid size={{ xs: 3, md: 3 }}>
            <Typography variant="body2"
              sx={{
                color: 'text.primary',
                paddingTop: 0,
                fontSize: 16,
              }}
            >
              {item.name}
            </Typography>
          </Grid>

          <Grid size={{ xs: 3, md: 2 }}>
            <Typography variant="body2"
              sx={{
                color: 'text.secondary',
                paddingTop: 0,
                fontSize: 16,
              }}
            >
              <b>{strCurrency(item.price)}</b>
            </Typography>
          </Grid>

          <Grid size={{ xs: 3, md: 3 }}>

            <TextField id="id-quantity"
              variant="outlined"
              value={item.quantity}
              type="number"
              label="Q.tà"
              disabled={orderCreated}
              onChange={changeCount ? (e) => changeCount(item.productID, e.target.value) : undefined}
              size="small"
              slotProps={{
                inputLabel: { shrink: true },
              }}
              InputProps={{
                inputProps: {
                  max: 100, min: 0
                }
              }}
            />

          </Grid>

          <Grid size={{ xs: 3, md: 3 }}>
            <RemoveFromCartComponent
              orderCreated={orderCreated}
              productID={item.productID}
              quantity={item.quantity}
              price={item.price}
              removeFromCartHandler={removeFromCartHandler ? removeFromCartHandler : undefined}
            />
          </Grid>

        </Grid>

    </>
  );
};

export default CartItemComponent;
